import React, { useContext } from 'react';
import { useStandings } from '../hooks/standings';
import StandingsRow from '../components/Standings/StandingsRow';
import { DataContext } from '../context/data-context';
import { filterStandings } from '../utils/functionalUtils';

export default function StandingsTableBody() {
  const { currentSeason } = useContext(DataContext);
  const [data] = useStandings(currentSeason);
  if (!data) return null;
  const standings = filterStandings(data);

  return standings?.map((item) => <StandingsRow data={item} key={item.id} />);
}
